/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoPilotEquipLogListPilotEquipLogData model module.
 * @module model/LogControllerDtoPilotEquipLogListPilotEquipLogData
 * @version 1.0
 */
class LogControllerDtoPilotEquipLogListPilotEquipLogData {
    /**
     * Constructs a new <code>LogControllerDtoPilotEquipLogListPilotEquipLogData</code>.
     * @alias module:model/LogControllerDtoPilotEquipLogListPilotEquipLogData
     */
    constructor() { 
        
        LogControllerDtoPilotEquipLogListPilotEquipLogData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LogControllerDtoPilotEquipLogListPilotEquipLogData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoPilotEquipLogListPilotEquipLogData} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoPilotEquipLogListPilotEquipLogData} The populated <code>LogControllerDtoPilotEquipLogListPilotEquipLogData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoPilotEquipLogListPilotEquipLogData();

            if (data.hasOwnProperty('logNo')) {
                obj['logNo'] = ApiClient.convertToType(data['logNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('slotNumber')) {
                obj['slotNumber'] = ApiClient.convertToType(data['slotNumber'], 'Number');
            }
            if (data.hasOwnProperty('type')) {
                obj['type'] = ApiClient.convertToType(data['type'], 'String');
            }
            if (data.hasOwnProperty('walletTransactionNo')) {
                obj['walletTransactionNo'] = ApiClient.convertToType(data['walletTransactionNo'], 'String');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoPilotEquipLogListPilotEquipLogData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoPilotEquipLogListPilotEquipLogData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['type'] && !(typeof data['type'] === 'string' || data['type'] instanceof String)) {
            throw new Error("Expected the field `type` to be a primitive type in the JSON string but got " + data['type']);
        }
        // ensure the json data is a string
        if (data['walletTransactionNo'] && !(typeof data['walletTransactionNo'] === 'string' || data['walletTransactionNo'] instanceof String)) {
            throw new Error("Expected the field `walletTransactionNo` to be a primitive type in the JSON string but got " + data['walletTransactionNo']);
        }

        return true;
    }


}



/**
 * @member {Number} logNo
 */
LogControllerDtoPilotEquipLogListPilotEquipLogData.prototype['logNo'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoPilotEquipLogListPilotEquipLogData.prototype['accountNo'] = undefined;

/**
 * @member {Number} nftUid
 */
LogControllerDtoPilotEquipLogListPilotEquipLogData.prototype['nftUid'] = undefined;

/**
 * @member {Number} slotNumber
 */
LogControllerDtoPilotEquipLogListPilotEquipLogData.prototype['slotNumber'] = undefined;

/**
 * @member {String} type
 */
LogControllerDtoPilotEquipLogListPilotEquipLogData.prototype['type'] = undefined;

/**
 * @member {String} walletTransactionNo
 */
LogControllerDtoPilotEquipLogListPilotEquipLogData.prototype['walletTransactionNo'] = undefined;

/**
 * @member {Date} createdAt
 */
LogControllerDtoPilotEquipLogListPilotEquipLogData.prototype['createdAt'] = undefined;






export default LogControllerDtoPilotEquipLogListPilotEquipLogData;

